// Cada item possui actions[]. A primeira action é sempre "visualizar" (master switch).
// Quando visualizar=false, todas as outras actions são desabilitadas automaticamente.
export const MODULES_CONFIG = [
  {
    label: "Agenda",
    key: "agenda",
    items: [
      {
        key: "agenda",
        label: "Agenda",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
          { key: "btnListaEspera", label: "Btn. Lista de Espera" },
          { key: "btnMapaSala", label: "Btn. Mapa de Sala" },
        ],
      },
      {
        key: "mapaDeSala",
        label: "Mapa de Sala",
        actions: [{ key: "visualizar", label: "Visualizar" }],
      },
      {
        key: "notificacoes",
        label: "Notificações",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "marcarLida", label: "Marcar como Lida" },
        ],
      },
    ],
  },
  {
    label: "Pacientes",
    key: "pacientes",
    items: [
      {
        key: "listaPacientes",
        label: "Lista de Pacientes",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
          { key: "exportar", label: "Exportar" },
        ],
      },
      {
        key: "listaEspera",
        label: "Lista de Espera",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Adicionar" },
          { key: "deletar", label: "Remover" },
        ],
      },
      {
        key: "relatorioConsultas",
        label: "Relatório de Consultas",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "exportar", label: "Exportar" },
        ],
      },
    ],
  },
  {
    label: "Administrativo",
    key: "administrativo",
    items: [
      {
        key: "clinicas",
        label: "Clínicas",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
        ],
      },
      {
        key: "especialidades",
        label: "Especialidades",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
        ],
      },
      {
        key: "pacotes",
        label: "Pacotes e Planos",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
        ],
      },
      {
        key: "procedimentos",
        label: "Procedimentos",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
        ],
      },
      {
        key: "materiaisPadrao",
        label: "Materiais Padrão por Procedimento",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Ativar / Inativar" },
        ],
      },
      {
        key: "tabelaProcedimentos",
        label: "Tabela de Procedimentos",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
        ],
      },
      {
        key: "colaboradores",
        label: "Colaboradores",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
        ],
      },
      {
        key: "profissionaisSaude",
        label: "Profissionais de Saúde",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
        ],
      },
      {
        key: "turnoTrabalho",
        label: "Turno de Trabalho",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
        ],
      },
      {
        key: "repasses",
        label: "Repasses",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
        ],
      },
      {
        key: "contratos",
        label: "Contratos",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
        ],
      },
      {
        key: "gerenciamentoPlanos",
        label: "Gerenciamento de Planos",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
        ],
      },
      {
        key: "relatorios",
        label: "Relatórios",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "exportar", label: "Exportar" },
        ],
      },
      {
        key: "assinaturaEletronica",
        label: "Assinatura Eletrônica",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "assinar", label: "Assinar" },
        ],
      },
      {
        key: "chatInterno",
        label: "Chat Interno",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "enviar", label: "Enviar Mensagem" },
        ],
      },
      {
        key: "tarefaRecado",
        label: "Tarefa / Recado",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
        ],
      },
    ],
  },
  {
    label: "Prontuários",
    key: "prontuarios",
    items: [
      {
        key: "prontuarios",
        label: "Prontuários",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
        ],
      },
      {
        key: "anamnese",
        label: "Anamnese",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
        ],
      },
      {
        key: "atestados",
        label: "Atestado",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "imprimir", label: "Imprimir" },
        ],
      },
      {
        key: "encaminhamentos",
        label: "Encaminhamentos",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "imprimir", label: "Imprimir" },
        ],
      },
      {
        key: "solicitacaoProcedimentos",
        label: "Solicitação de Procedimentos",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "imprimir", label: "Imprimir" },
        ],
      },
      {
        key: "prescricoes",
        label: "Prescrições",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "imprimir", label: "Imprimir" },
        ],
      },
      {
        key: "comprovacaoHoras",
        label: "Comprovação de Horas",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "imprimir", label: "Imprimir" },
        ],
      },
      {
        key: "orcamentos",
        label: "Orçamento",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "imprimir", label: "Imprimir" },
        ],
      },
      {
        key: "documentoPadrao",
        label: "Documento Padrão",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
        ],
      },
    ],
  },
  {
    label: "Convênios",
    key: "convenios",
    items: [
      {
        key: "cadastro",
        label: "Cadastro de Convênio",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
        ],
      },
      {
        key: "tabelaProcedimentos",
        label: "Tabela de Procedimentos",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
        ],
      },
      {
        key: "guiasConsulta",
        label: "Guias de Consulta SP/SADT",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
        ],
      },
      {
        key: "lote",
        label: "Lote",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
        ],
      },
      {
        key: "repasse",
        label: "Repasse",
        actions: [{ key: "visualizar", label: "Visualizar" }],
      },
      {
        key: "gestaoGlosa",
        label: "Gestão de Glosa",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "editar", label: "Editar" },
        ],
      },
    ],
  },
  {
    label: "Finanças",
    key: "financas",
    items: [
      {
        key: "fiscal",
        label: "Fiscal",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "configurar", label: "Configurar" },
          { key: "emitir", label: "Emitir" },
          { key: "cancelar", label: "Cancelar" },
          { key: "corrigir", label: "Corrigir" },
        ],
      },
      {
        key: "contasBancarias",
        label: "Contas Bancárias",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
        ],
      },
      {
        key: "centroCusto",
        label: "Centro de Custo",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
        ],
      },
      {
        key: "fornecedores",
        label: "Fornecedores",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
        ],
      },
      {
        key: "formaPagamento",
        label: "Forma de Pagamento",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
        ],
      },
      {
        key: "contasPagar",
        label: "Contas a Pagar",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
          { key: "exportar", label: "Exportar" },
        ],
      },
      {
        key: "transferencia",
        label: "Transferência entre Contas",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
        ],
      },
      {
        key: "contasReceber",
        label: "Contas a Receber",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
          { key: "exportar", label: "Exportar" },
        ],
      },
      {
        key: "aberturaCaixa",
        label: "Abertura de Caixa",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "abrir", label: "Abrir Caixa" },
        ],
      },
      {
        key: "fechamentoCaixa",
        label: "Fechamento de Caixa",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "fechar", label: "Fechar Caixa" },
        ],
      },
      {
        key: "sangria",
        label: "Sangria",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Realizar" },
        ],
      },
      {
        key: "reforco",
        label: "Reforço",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Realizar" },
        ],
      },
      {
        key: "conciliacao",
        label: "Conciliação Bancária",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "editar", label: "Editar" },
        ],
      },
      {
        key: "fluxoCaixa",
        label: "Fluxo de Caixa",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "exportar", label: "Exportar" },
        ],
      },
      {
        key: "dre",
        label: "DRE",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "exportar", label: "Exportar" },
        ],
      },
      {
        key: "descontos",
        label: "Relatório de Descontos",
        actions: [
          { key: "visualizar", label: "Visualizar" },
        ],
      },
    ],
  },
  {
    label: "Almoxarifado",
    key: "almoxarifado",
    items: [
      {
        key: "cadastroProduto",
        label: "Cadastro de Produto",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
        ],
      },
      {
        key: "entradaProduto",
        label: "Entrada de Produto",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Registrar" },
          { key: "editar", label: "Editar" },
        ],
      },
      {
        key: "saidaProduto",
        label: "Saída de Produto",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Registrar" },
          { key: "editar", label: "Editar" },
        ],
      },
      {
        key: "estoque",
        label: "Estoque",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "exportar", label: "Exportar" },
        ],
      },
      {
        key: "almoxarifados",
        label: "Locais de Estoque",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
        ],
      },
    ],
  },
  {
    label: "CRM - Marketing",
    key: "crm",
    items: [
      {
        key: "automacaoWhatsapp",
        label: "Automação do WhatsApp",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
        ],
      },
      {
        key: "emailMarketing",
        label: "E-mail Marketing",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
        ],
      },
      {
        key: "automacaoPredefinida",
        label: "Automação Pré-definida",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "ativar", label: "Ativar / Desativar" },
        ],
      },
      {
        key: "automacaoPersonalizada",
        label: "Automação Personalizada",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
        ],
      },
      {
        key: "nps",
        label: "NPS",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
        ],
      },
      {
        key: "leads",
        label: "Leads",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
          { key: "btnNovoLead", label: "Btn. Novo Lead" },
        ],
      },
      {
        key: "funilVendas",
        label: "Funil de Vendas",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "editar", label: "Editar" },
        ],
      },
      {
        key: "clubeFidelidade",
        label: "Club de Fidelidade",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
        ],
      },
    ],
  },
  {
    label: "Gestão do Negócio",
    key: "gestaoNegocio",
    items: [
      { key: "canvaModelo", label: "Canva Modelo de Negócio", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "editar", label: "Editar" }] },
      { key: "proposito", label: "Propósito, missão, visão e valores", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "editar", label: "Editar" }] },
      { key: "analiseSwot", label: "Análise SWOT", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "editar", label: "Editar" }] },
      { key: "metasSmart", label: "Metas SMART", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "editar", label: "Editar" }] },
      { key: "cincoW2H", label: "5W 2H", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "editar", label: "Editar" }] },
      { key: "planejamentoMetas", label: "Planejamento das Metas Financeiras", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "editar", label: "Editar" }] },
      { key: "precificacao", label: "Precificação", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "editar", label: "Editar" }] },
      { key: "pontoEquilibrio", label: "Ponto de Equilíbrio", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "editar", label: "Editar" }] },
      { key: "pdca", label: "PDCA", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "editar", label: "Editar" }] },
      { key: "descritivoFuncao", label: "Descritivo de Função", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "editar", label: "Editar" }] },
      { key: "disc", label: "DISC", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "editar", label: "Editar" }] },
      { key: "tributacao", label: "Tributação", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "editar", label: "Editar" }] },
    ],
  },
  {
    label: "Dashboard",
    key: "dashboard",
    items: [
      { key: "agenda", label: "Agenda", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "exportar", label: "Exportar" }] },
      { key: "pacientes", label: "Pacientes", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "exportar", label: "Exportar" }] },
      { key: "administrativo", label: "Administrativo", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "exportar", label: "Exportar" }] },
      { key: "convenios", label: "Convênios", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "exportar", label: "Exportar" }] },
      { key: "financeiro", label: "Financeiro", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "exportar", label: "Exportar" }] },
      { key: "almoxarifado", label: "Almoxarifado", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "exportar", label: "Exportar" }] },
      { key: "marketing", label: "Marketing", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "exportar", label: "Exportar" }] },
      { key: "gestaoNegocio", label: "Gestão do Negócio", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "exportar", label: "Exportar" }] },
    ],
  },
  {
    label: "Integrações",
    key: "integracoes",
    items: [
      { key: "doctoralia", label: "Doctoralia", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "configurar", label: "Configurar" }] },
      { key: "totalPass", label: "TotalPass", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "configurar", label: "Configurar" }] },
      { key: "wellhub", label: "Wellhub", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "configurar", label: "Configurar" }] },
      { key: "doc4sign", label: "Doc4sign", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "configurar", label: "Configurar" }] },
      { key: "googleCalendar", label: "Google Calendar", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "configurar", label: "Configurar" }] },
      { key: "memed", label: "Memed", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "configurar", label: "Configurar" }] },
      { key: "nfEletronica", label: "NF Eletrônica", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "configurar", label: "Configurar" }] },
      { key: "apiWhatsapp", label: "API oficial WhatsApp", actions: [{ key: "visualizar", label: "Visualizar" }, { key: "configurar", label: "Configurar" }] },
      { key: "personalizacao", label: "Personalização", actions: [{ key: "visualizar", label: "Visualizar" }] },
    ],
  },
  {
    label: "Configurações",
    key: "configuracoes",
    items: [
      {
        key: "configuracoes",
        label: "Configurações",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "editar", label: "Editar" },
        ],
      },
      {
        key: "controleUsuario",
        label: "Controle de Usuário",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "criar", label: "Criar" },
          { key: "editar", label: "Editar" },
          { key: "deletar", label: "Deletar" },
          { key: "gerenciarPermissoes", label: "Gerenciar Permissões" },
        ],
      },
      {
        key: "configuracaoAlerta",
        label: "Configuração de Alerta",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "editar", label: "Editar" },
        ],
      },
      {
        key: "vinculadas",
        label: "Vinculadas",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "editar", label: "Editar" },
        ],
      },
      {
        key: "historicoLogs",
        label: "Histórico de Logs",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "exportar", label: "Exportar" },
        ],
      },
      {
        key: "exportarInformacoes",
        label: "Exportar Informações",
        actions: [{ key: "executar", label: "Executar" }],
      },
      {
        key: "agendamentoOnline",
        label: "Agendamento Online",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "configurar", label: "Configurar" },
        ],
      },
      {
        key: "parametro",
        label: "Parâmetro",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "configurar", label: "Configurar" },
        ],
      },
      {
        key: "pontoEletronico",
        label: "Ponto Eletrônico",
        actions: [
          { key: "visualizar", label: "Visualizar" },
          { key: "configurar", label: "Configurar" },
        ],
      },
    ],
  },
];

// ─── helpers ────────────────────────────────────────────────────────────────

export const buildDefaultPermissions = () =>
  Object.fromEntries(
    MODULES_CONFIG.map(({ key, items }) => [
      key,
      {
        status: false,
        ...Object.fromEntries(
          items.map(({ key: iKey, actions }) => [
            iKey,
            Object.fromEntries(actions.map(({ key: aKey }) => [aKey, false])),
          ])
        ),
      },
    ])
  );

export const mergePermissions = (existing) => {
  const defaults = buildDefaultPermissions();
  if (!existing) return defaults;
  return Object.fromEntries(
    MODULES_CONFIG.map(({ key, items }) => {
      const mergedItems = Object.fromEntries(
        items.map(({ key: iKey, actions }) => [
          iKey,
          Object.fromEntries(
            actions.map(({ key: aKey }) => [
              aKey,
              existing[key]?.[iKey]?.[aKey] ?? false,
            ])
          ),
        ])
      );
      const status = items.some(({ key: iKey }) =>
        Object.values(mergedItems[iKey]).some(Boolean)
      );
      return [key, { status, ...mergedItems }];
    })
  );
};
